import { useState, useEffect } from 'react'

export type GlobalUiProps<T> = {
  key: string
  initialValue: T
}

export default function useGlobalUI<T>(options: GlobalUiProps<T>) {
  const { key, initialValue } = options

  const [state, setState] = useState<T>(() => {
    const storedValue = localStorage.getItem(key)
    return storedValue ? JSON.parse(storedValue) : initialValue
  })

  const updateFunction = (value: T) => {
    setState(value)
    localStorage.setItem(key, JSON.stringify(value))
  }

  useEffect(() => {
    const storedValue = localStorage.getItem(key)
    if (storedValue) {
      setState(JSON.parse(storedValue))
    }
  }, [key])

  return [state, updateFunction] as const
}
